import { $post } from "./base";

export async  function geocoding(address=""){
    return  $post("store/getMapAddressEncode",{address})

}